import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ml-sk-spinner-3',
  templateUrl: './sk-spinner-3.component.html',
  styleUrls: ['./sk-spinner-3.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class SkSpinner3Component {}
